var map = {
	"./jiqi-txt.png": "RTlB",
	"./jiqi-txt1.png": "1cci",
	"./jiqi-txt2.png": "JygU",
	"./jiqi-txt3.png": "BG+O",
	"./jiqi-txt4.png": "4rwh",
	"./jiqi-txt5.png": "WaSz",
	"./jiqi-txt6.png": "afGt",
	"./jiqi-txt7.png": "Fjo5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AHWI";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img ^\.\/jiqi\-txt.*\.png$
// module id = AHWI
// module chunks = 0